import { datadogRum } from '@datadog/browser-rum';

const dataDogLogger = _store => next => action => {
  try {
    if (action.type.endsWith('ERROR')) {
      const error = action.payload;
      const errorToReport = error instanceof Error ? error : new Error(error);
      datadogRum.addError(errorToReport, {
        action: action.type,
        customType: 'redux'
      });
    }
  } catch (error) {
    console.error('Error attempting to log to DataDog', error);
  }
  try {
    if (action.type === 'driversLicense/LOG_PERSONA_EVENT') {
      const { logEvent, logMeta } = action.payload;
      datadogRum.addAction(`Persona Event - ${logEvent}`, logMeta);
    }
  } catch (error) {
    console.error('Error attempting to log to DataDog', error);
  }
  return next(action);
};

export default dataDogLogger;
